interface IconProps {
  fillColor: string
}

export const ErrorIcon = ({ fillColor }: IconProps) => {
  return (
    <div className="illustration__icon-wrapper">
      <svg
        aria-hidden="true"
        width="120"
        height="120"
        viewBox="0 0 120 120"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M89.2229 78.9718L63.4011 36.1249C61.9079 33.6472 58.0921 33.6472 56.5989 36.1249L30.7771 78.9718C29.4016 81.254 31.0188 84.4 34.1781 84.4H85.8219C88.9812 84.4 90.5984 81.254 89.2229 78.9718ZM65.3424 34.955C62.968 31.015 57.032 31.015 54.6575 34.955L28.8357 77.8018C26.4613 81.7417 29.4293 86.6667 34.1781 86.6667H85.8219C90.5707 86.6667 93.5387 81.7417 91.1643 77.8018L65.3424 34.955Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M60.0001 47.8C58.5578 47.8 57.4419 49.0641 57.6208 50.4952L59.626 66.5364C59.6496 66.7251 59.81 66.8667 60.0001 66.8667C60.1903 66.8667 60.3507 66.7251 60.3742 66.5364L62.3794 50.4952C62.5583 49.0641 61.4424 47.8 60.0001 47.8ZM55.3717 50.7763C55.0237 47.9923 57.1944 45.5333 60.0001 45.5333C62.8058 45.5333 64.9766 47.9923 64.6286 50.7763L62.6234 66.8175C62.458 68.1405 61.3334 69.1333 60.0001 69.1333C58.6668 69.1333 57.5422 68.1405 57.3768 66.8175L55.3717 50.7763Z"
          fill={fillColor}
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M59.9999 73.1333C59.153 73.1333 58.4665 73.8198 58.4665 74.6667C58.4665 75.5135 59.153 76.2 59.9999 76.2C60.8467 76.2 61.5332 75.5135 61.5332 74.6667C61.5332 73.8198 60.8467 73.1333 59.9999 73.1333ZM56.1999 74.6667C56.1999 72.568 57.9012 70.8667 59.9999 70.8667C62.0986 70.8667 63.7999 72.568 63.7999 74.6667C63.7999 76.7653 62.0986 78.4667 59.9999 78.4667C57.9012 78.4667 56.1999 76.7653 56.1999 74.6667Z"
          fill={fillColor}
        />
      </svg>
    </div>
  )
}
